/* eslint-disable  */

Array.prototype.contemString = function (scope) {
  const i = this.find(scopeUser => scopeUser === scope);
  return i;
}
